import { Kanban as _Kanban } from './Kanban.component';
import { KanbanCard } from './KanbanCard';

export const Kanban = Object.assign(_Kanban, {
  Item: KanbanCard,
});
